import { useMutation } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

const saveCasinoConfigurationProvider = async ({
  mode,
  providerId,
  providerName,
  iconUrl,
  isActive,
}) => {
  const token = JSON.parse(localStorage.getItem("token"));
  const privateInstance = createPrivateAdminPanelInstance(token?.AccessToken);

  if (mode === "create") {
    const response = await privateInstance.post(
      API_ROUTES.REGISTER_ADMIN_PROVIDER,
      {
        identifier: providerId,
        name: providerName,
        icon_url: iconUrl || null,
        is_active: isActive,
      },
    );
    return response?.data ?? null;
  }

  const route = API_ROUTES.UPDATE_ADMIN_PROVIDER.replace(
    "{identifier}",
    encodeURIComponent(providerId),
  );
  const response = await privateInstance.patch(route, {
    name: providerName,
    icon_url: iconUrl || null,
    is_active: isActive,
  });
  return response?.data ?? null;
};

export const useSaveCasinoConfigurationProvider = () =>
  useMutation({
    mutationKey: ["casinoConfiguration", "providers", "save"],
    mutationFn: saveCasinoConfigurationProvider,
  });

export { saveCasinoConfigurationProvider };
